<div *ngIf="item.children?.length"
     class="kt-menu-item kt-menu-item-accordion"
     data-kt-menu-item-toggle="accordion"
     data-kt-menu-item-trigger="click"
     [class.show]="isExpanded">

								<div class="kt-menu-link border border-transparent grow cursor-pointer gap-[14px] ps-[10px] pe-[10px] py-[8px]"
									tabindex="0">
									<span
										class="kt-menu-bullet flex w-[6px] -start-[3px] rtl:start-0 relative before:absolute before:top-0 before:size-[6px] before:rounded-full rtl:before:translate-x-1/2 before:-translate-y-1/2 kt-menu-item-active:before:bg-primary kt-menu-item-hover:before:bg-primary">
									</span>
									<span
										class="kt-menu-title text-2sm font-normal me-1 text-foreground kt-menu-item-active:text-primary kt-menu-item-active:font-medium kt-menu-link-hover:!text-primary">
										{{item.name}}
									</span>
									<span
										class="kt-menu-arrow text-muted-foreground w-[20px] shrink-0 justify-end ms-1 me-[-10px]">
										<span class="inline-flex kt-menu-item-show:hidden">
											<i class="ki-filled ki-plus text-[11px]">
											</i>
										</span>
										<span class="hidden kt-menu-item-show:inline-flex">
											<i class="ki-filled ki-minus text-[11px]">
											</i>
										</span>
									</span>
								</div>
								<div
                  class="kt-menu-accordion gap-1 relative before:absolute before:start-[32px] ps-[22px] before:top-0 before:bottom-0 before:border-s before:border-border"
                  [class.show]="isExpanded">
                   <ng-container *ngFor="let child of item.children">
                     <div class="kt-menu-item">
                      <a
                        class="kt-menu-link border border-transparent items-center grow hover:bg-accent/60 hover:rounded-lg gap-[5px] ps-[10px] pe-[10px] py-[8px]"
                        [routerLink]="child.route"
                        routerLinkActive="bg-accent/60 rounded-lg"
                        tabindex="0">
                        <span
                          class="kt-menu-bullet flex w-[6px] -start-[3px] rtl:start-0 relative before:absolute before:top-0 before:size-[6px] before:rounded-full rtl:before:translate-x-1/2 before:-translate-y-1/2 kt-menu-item-active:before:bg-primary kt-menu-item-hover:before:bg-primary">
                        </span>
                        <span
                          class="kt-menu-title text-2sm font-normal text-foreground kt-menu-item-active:text-primary kt-menu-item-active:font-semibold kt-menu-link-hover:!text-primary">
                          {{child.name}}
                        </span>
                      </a>
                    </div>
                  </ng-container>
	
								</div>
							</div>
							
							<div *ngIf="!item.children?.length" class="kt-menu-item">
								<a class="kt-menu-link border border-transparent items-center grow kt-menu-item-active:bg-accent/60 dark:menu-item-active:border-border kt-menu-item-active:rounded-lg hover:bg-accent/60 hover:rounded-lg gap-[14px] ps-[10px] pe-[10px] py-[8px]"
									[routerLink]="item.route" tabindex="0">
									<span
										class="kt-menu-bullet flex w-[6px] -start-[3px] rtl:start-0 relative before:absolute before:top-0 before:size-[6px] before:rounded-full rtl:before:translate-x-1/2 before:-translate-y-1/2 kt-menu-item-active:before:bg-primary kt-menu-item-hover:before:bg-primary">
									</span>
									<span
										class="kt-menu-title text-2sm font-normal text-foreground kt-menu-item-active:text-primary kt-menu-item-active:font-semibold kt-menu-link-hover:!text-primary">
										{{item.name}}
									</span>
								</a>
							</div>